// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"CycIR","eventItem":"_3tUem","title":"_2x3Xg","time":"_3o45E","sectionTitle":"_2kVoo","section":"_36ccM"};